// src/navigation/wrappers/CreatorNavigationWrapper.jsx
import React from 'react';
import CreatorNav from '../../components/CreatorNav';
import CreatorTopMenuBar from '../../components/CreatorTopMenuBar';
import CreatorMobileBottomNav from '../../components/CreatorMobileBottomNav';
import UniversalFooter from '../../components/UniversalFooter';

const CreatorNavigationWrapper = ({ children }) => {
  return (
    <>
      <CreatorNav />
      <CreatorTopMenuBar />
      {children}
      <CreatorMobileBottomNav />
      <UniversalFooter />
    </>
  );
};

export default CreatorNavigationWrapper;
